var React = require('react');

function ThinClose (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.2207 12.3936L13.2246 0.388672","stroke":"white","key":0}),React.createElement("path",{"d":"M1.21973 0.388671L13.2246 12.3926","stroke":"white","key":1})]);
}

ThinClose.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = ThinClose;

ThinClose.default = ThinClose;
